<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>API Documentation</glxy-page-title>
  </glxy-page-toolbar>
  <glxy-page-wrapper widthPreset="full">
    <div class="stoplight-container">
      <elements-stoplight-project
        projectId="{{ projectId }}"
        router="history"
        basePath="{{ basePath }}"
        collapseTableOfContents="true"
        hideMocking="true"
      ></elements-stoplight-project>
    </div>
  </glxy-page-wrapper>
</glxy-page>
<!-- https://docs.stoplight.io/docs/elements/d55906b5db04b-dev-portal-configuration-options -->
